import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Delivery } from "@/services/backend/samples/types/delivery";
import { Button } from "@/shared/components/ui/button";
import { X } from "lucide-react";
import { ReactNode } from "react";
import {
  CommonDialogFooter,
  CommonDialogHeader,
} from "@/shared/components/dialog/dialog-common";
import { useSamplesDeliveryCancelMutation } from "@/services/backend/samples/api/delivery-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import t from "@/lang/lang";

export function CancelDeliveryDialog({
  delivery,
  trigger,
}: {
  delivery: Delivery;
  trigger?: ReactNode;
}) {
  const [cancel, { isLoading, error }] = useSamplesDeliveryCancelMutation();

  const doCancel = () => {
    if (isLoading) return;

    cancel({ id: delivery.id });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger || (
          <Button size="sm" variant="outline">
            <X />
          </Button>
        )}
      </DialogTrigger>
      <DialogContent>
        <CommonDialogHeader
          title={t("Lieferung stornieren")}
          description={t("Die Lieferung wird als storniert markiert.")}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doCancel} />
      </DialogContent>
    </Dialog>
  );
}
